import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.ShippingLineItemView.';
  public static readonly shipping = `${Id.prefix}shipping`;
  public static readonly isTaxableItem = `${Id.prefix}isTaxableItem`;
  public static readonly title = `${Id.prefix}title`;
  public static readonly description = `${Id.prefix}description`;
  public static readonly cost = `${Id.prefix}cost`;
  public static readonly notes = `${Id.prefix}notes`;
}

export class LangShippingLineItemView {
  private constructor() {}
  public static shipping(): string {
    return interpolate(Id.shipping);
  }
  public static isTaxableItem(): string {
    return interpolate(Id.isTaxableItem);
  }
  public static title(): string {
    return interpolate(Id.title);
  }
  public static description(): string {
    return interpolate(Id.description);
  }
  public static cost(): string {
    return interpolate(Id.cost);
  }
  public static notes(): string {
    return interpolate(Id.notes);
  }
}

export class ShippingLineItemViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Dialog Titles and Labels
    register.add(Id.shipping, 'Shipping', 'Dialog title for shipping line item');
    register.add(Id.isTaxableItem, 'Is Taxable Item', 'Switch label for taxable item');
    register.add(Id.title, 'Title', 'Label for shipping item title');
    register.add(Id.description, 'Description', 'Label for shipping item description');
    register.add(Id.cost, 'Cost', 'Label for shipping item cost');
    register.add(Id.notes, 'Notes', 'Label for shipping item notes');
  }
}
